import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import Dialog from '../../common/dialog'
import Export from './export'
import Import from './import'

class ImportExport extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      //all or area
      selectedTab: 'import'
    }
  }

  setBounds(bounds) {
    this.setState({ bounds })
  }

  getExports() {

  }

  render() {
    const { collapseLeftToolbar } = this.props
    return (
      <div className='left-expanded-content-container'>
        <div className='left-expanded-header-container'>
          <span className='left-expanded-header'>Imp/Exp Map</span>
          <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
        </div>
        <div className='left-expanded-tabs-container'>
          {[
            this.makeTab({
              tab: 'import',
              label: 'Import File',
              active: '../../../../../asset/Import_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Import_Solid_4F4F4F_hdpi.png'
            }, '50%'),
            this.makeTab({
              tab: 'export',
              label: 'Export File',
              active: '../../../../../asset/Export_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Export_Solid_4F4F4F_hdpi.png'
            }, '50%')
          ]}
        </div>
        {
          this.state.selectedTab === 'import' ? < Import /> : <Export />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(ImportExport)